import { useContext } from 'react';
import { GuardContext, GuardResourceContext } from './context';
export var useGuard = function () {
    var guard = useContext(GuardContext).guard;
    var resourceName = useContext(GuardResourceContext).resourceName;
    return {
        canAction: function (action, specifiedResourceName) {
            var protectedResourceName = specifiedResourceName || resourceName;
            if (!protectedResourceName) {
                throw new Error('useGuard error: you must defined resourceName as argument or by context');
            }
            return guard.can(protectedResourceName, action);
        }
    };
};
//# sourceMappingURL=hooks.js.map